import React from 'react';
import { MILE } from 'utils/distanceTypes';
import noop from 'utils/noop';
import {
  GeoLabel,
  StyledCoreDistancePicker,
  StyledCoreLocationPicker,
} from './CriteriaPropertyField.styled';

// type Props = {
//   /** Class of the text field. */
//   className: string,
//   /** Additional content of the geo location field. */
//   content: node,
//   /** If the text field is disabled. */
//   disabled: boolean,
//   /** The distance value object */
//   distance: {},
//   /** If the field has an error. */
//   error: boolean,
//   /** Array comtaining the group index, query index and criteria property index. */
//   fieldIdentifier: [],
//   /** Hide the location picker. */
//   hideLocationPicker: boolean,
//   /** If the field is dynamic. */
//   isDynamic: boolean,
//   /** The location value object. */
//   location: {},
//   /** Callback function when field value is changed. */
//   onChange: () => {},
//   /** Placeholder test of the field. */
//   placeholder: string,
// };

export default class CriteriaGeoLocationField extends React.Component {
  static defaultProps = {
    distance: { distance: 0, units: MILE },
    fieldIdentifier: [],
    location: { lat: 0, lon: 0 },
    onChange: noop,
    disabled: false,
  };

  /**
   * getDistanceUnitFromDistance
   * Helper function to get the distance and unit values from the distance object.
   * @param { Object } distanceObj: The distance object.
   * @returns { Object } Object containing distance and unit values.
   */
  getDistanceUnitFromDistance = (distanceObj) => {
    const { distance, unit } = distanceObj || { distance: 0, unit: MILE };
    return { distance, unit };
  };

  /**
   * getLatLonFromLocation
   * Helper function to get the lat and lon values from the location object.
   * @param { Object } location: The location object.
   * @returns { Object } Object containing lat and lon values.
   */
  getLatLonFromLocation = (location) => {
    const { lat, lon } = location || { lat: 0, lon: 0 };
    return { lat, lon };
  };

  /**
   * handleDistanceChange
   * Callback function when distance value changes.
   * @param { Object } e: The change event.
   * @param { Object } updatedProps: The updated distance values.
   * @returns { void }
   */
  handleDistanceChange = (e, { distance, unit }) => {
    const { fieldIdentifier, location, onChange } = this.props;
    const { lat, lon } = this.getLatLonFromLocation(location);
    onChange(lat, lon, distance, unit, ...fieldIdentifier);
  };

  /**
   * handleLocationChange
   * Callback function when location value changes.
   * @param { Object } e: The change event.
   * @param { Object } updatedProps: The updated location values.
   * @returns { void }
   */
  handleLocationChange = (e, { lat, lon }) => {
    const { distance: distanceObj, fieldIdentifier, onChange } = this.props;
    const { distance, unit } = this.getDistanceUnitFromDistance(distanceObj);
    onChange(lat, lon, distance, unit, ...fieldIdentifier);
  };

  render() {
    const { content, distance: distanceObj, hideLocationPicker, location, disabled } = this.props;
    const { distance, unit } = this.getDistanceUnitFromDistance(distanceObj);
    const { lat, lon } = this.getLatLonFromLocation(location);
    return (
      <>
        <StyledCoreDistancePicker
          distance={distance}
          inQueryBuilder
          onChange={this.handleDistanceChange}
          unit={unit}
          disabled={disabled}
        />
        <GeoLabel data-test="criteria-geo-location-input">of</GeoLabel>
        {!hideLocationPicker && (
          <StyledCoreLocationPicker
            inQueryBuilder
            onChange={this.handleLocationChange}
            lat={lat}
            lon={lon}
            disabled={disabled}
          />
        )}
        {content}
      </>
    );
  }
}
